import { render, staticRenderFns } from "./DateRangeCustom.vue?vue&type=template&id=180a27ce&scoped=true"
import script from "./DateRangeCustom.vue?vue&type=script&lang=ts"
export * from "./DateRangeCustom.vue?vue&type=script&lang=ts"
import style0 from "./DateRangeCustom.vue?vue&type=style&index=0&id=180a27ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180a27ce",
  null
  
)

export default component.exports